import { WebAPIClient } from "../../api";
import { ApiEndPoints } from "../../api/api-end-points";
import { APIResult } from "../../models/api-results";
import { Job, JobFilterparam } from "../../models/job/job";
import { BaseSearchParam } from "../../models/base-search-param";
import { Invoice } from "../../models/invoice/invoice";
import { InvoiceSearchParam } from "../../models/invoice/invoice-search-param";

export async function GetInvoices(param: InvoiceSearchParam, sort?: string, pageSize?: number, pageNumber?: number): Promise<APIResult<Invoice[]>> {

    const searchParams = new BaseSearchParam(param, sort, pageSize, pageNumber);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.invoice_search}${queryString}`;
    return await WebAPIClient.getData<Invoice[]>(apiUrl);
}


export async function ViewInvoiceId(invoiceId: string): Promise<any> {
    const apiUrl = `${ApiEndPoints.invoice_view}`;
    return await WebAPIClient.getBlobData<any>(apiUrl.replace("{id}", (invoiceId ?? 0).toString()));
}

export async function ResetInvoice(id: string): Promise<APIResult<Invoice>> {
    const apiUrl = `${ApiEndPoints.invoice_reset}`;
    return await WebAPIClient.postData<Invoice>(apiUrl.replace("{id}", (id ?? 0).toString()), {});
}
